import './index.css';

/**
 * Full-bleed dark loading state with a single neutral spinner — no text.
 *
 * Used everywhere the app is mid-bootstrap with no decision to show the user
 * yet: the lazy-route Suspense fallback, the silent-login decide/redirect
 * window on Home, and the OAuth callback's token exchange. Keeping one identical
 * visual across all of those makes the silent-login round-trip read as a single
 * continuous load instead of a sequence of distinct flashing pages.
 *
 * @param {{ label?: string }} props - accessible status label (visually hidden).
 */
export function LoadingScreen({ label = 'Loading…' }) {
  return (
    <div className="loading-screen" role="status" aria-busy="true">
      <span className="loading-screen__spinner" aria-hidden="true" />
      <span className="sr-only">{label}</span>
    </div>
  );
}
